export default "__VITE_ASSET__zu6eKHIv__"